import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var VariablesClass;
function Variables() {
  if (VariablesClass === VOID) {
    class $ {
      constructor(valueMap) {
        this.n46_1 = valueMap;
      }
    }
    initMetadataForClass($, 'Variables');
    VariablesClass = $;
  }
  return VariablesClass;
}
//region block: exports
export {
  Variables as Variables1mnjguxfc49u,
};
//endregion

//# sourceMappingURL=Executable.mjs.map
